import React, { useEffect, useState,} from "react";
import "./InitialAssessmentReport.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router";
const WorkApprovalReport = () => {
    const [data, setData] = useState(null);
    const { claimNumber } = useParams();
    const navigate = useNavigate();

useEffect(() => {
  const handlePopState = () => {
    navigate(`/claimlanding/${claimNumber}`, { replace: true });
  };

  window.addEventListener("popstate", handlePopState);
  return () => window.removeEventListener("popstate", handlePopState);
}, [navigate, claimNumber]);

    console.log("7", claimNumber);



    useEffect(() => {
        if (claimNumber) {
            axios
                .post(`/server/get-claim-data/${claimNumber}`)
                .then((response) => {
                    console.log("24", response.data);
                    setData(response.data)
                }
                )
                .catch((error) => console.error("Axios error:", error));
        }
    }, [claimNumber]);

    if (!data) return <div>Loading...</div>;
    return (
        <div className="report-container">
            <div className="report-header">
                <img src="/custom-icons/surveyorIcon.png" alt="Surveyor AI Logo" className="logo" />

                <div className="report-title">
                    <h2>Final Approval Report</h2>
                </div>

                <p className="printed-date">
                    Printed: {new Date().toLocaleDateString('en-IN', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                    })}
                </p>
            </div>

            <div className="inline-box-row">
                <div className="inline-box label">Policy Number</div>
                <div className="inline-box value">{data.policyNumber}</div>
                <div className="inline-box label">Claim Number</div>
                <div className="inline-box value">{data.claimNumber}</div>
                <div className="inline-box label">Ticket Number</div>
                <div className="inline-box value">--</div>
            </div>

            <div className="inline-box-row info-box">
                <div className="info-full-row">
                    <div className="inline-box label">Date:{new Date().toLocaleString('en-IN', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true
                    })}</div>
                    <div className="inline-box value">{data.date}</div>
                </div>

                <div className="info-row">
                    <div className="inline-box label">Name of Owner:</div>
                    <div className="inline-box value">{data.insured}</div>
                    <div className="inline-box label">Engine No.:</div>
                    <div className="inline-box value">{data.EngineNumber}</div>
                    <div className="inline-box label">Workshop Name:</div>
                    <div className="inline-box value">{data.hpa}</div>
                </div>

                <div className="info-row">
                    <div className="inline-box label">Registration No.:</div>
                    <div className="inline-box value">{data.VehicleRegistrationNumber}</div>
                    <div className="inline-box label">Surveyor Name:</div>
                    <div className="inline-box value">Not Mentioned</div>
                    {/* <div className="inline-box value">{data.surveyor}</div> */}
                    <div className="inline-box label">Workshop GST Number:</div>
                    <div className="inline-box value">--</div>
                </div>

                <div className="info-row">
                    <div className="inline-box label">Date of Reg.:</div>
                    <div className="inline-box value">{data.DateofRegistration}</div>
                    <div className="inline-box label">Claim Coordinator:</div>
                    <div className="inline-box value">--</div>
                    <div className="inline-box label">Date of Accident:</div>
                    <div className="inline-box value">{data.dateOfAccident}</div>
                </div>

                <div className="info-row">
                    <div className="inline-box label">Make & Model:</div>
                    <div className="inline-box value">{data.Make} {data.Variant}</div>
                    <div className="inline-box label">Chassis No.:</div>
                    <div className="inline-box value">{data.ChassisNumber}</div>
                    <div className="inline-box label">Vehicle Age (Years):</div>
                    <div className="inline-box value">--</div>
                </div>

                <div className="info-row">
                    <div className="inline-box label">Payment to:</div>
                    <div className="inline-box value">Workshop</div>
                    {/* <div className="inline-box value">{data.paymentTo}</div> */}
                </div>
            </div>

            <div className="note-section">
                <p>
                    "Please find the below tentative estimation for the subject vehicle as
                    per the visible damages found on the vehicle. Any further
                    replacement/repair of part required during the course of repair shall
                    be verified and included in the estimation. We request you to take
                    prior approval from the insurer for all kept open part approval, if
                    any. Any further replacement/repair of part required during the course
                    of repair shall be verified and included in the assessment subject to
                    the admissibility of the claim. We request you to take prior approval
                    from the insurer for all parts put on hold and are pending for
                    approval."
                </p>
                <p>
                    <strong>Important Notes:</strong>
                </p>
                <ul>
                    <li>
                        After completion of repair, you shall submit the vehicle for
                        reinspection and also produce the salvage of parts replaced.
                    </li>
                    <li>
                        Please have the final tax invoice raised in
                        Insurance Limited up to the Insurer liability, and the remaining
                        balance to be invoiced in favor of the Insured.
                    </li>
                </ul>
                {/* <p className="help-note">
                    For any further clarifications regarding your claim: Contact TPA at
                    support@insurancecompany.com or +91 9810498126
                </p> */}
                 <p className='help-note'>
          For any further clarifications regarding your claim: Contact TPA
          at&nbsp;
          {/* {formData.email_id || ' support@tpa.com'} or{' '}
          {formData.phone_number || ' +91-XXXXX-XXXXX'} */}
           {'surveyor@surveyor.com'} or {' +91-9876543210'}
        </p>
            </div>

            <h4 className="section-heading">PARTS</h4>
            <table className="parts-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>JOB</th>
                        <th>MATERIAL</th>
                        <th>DESCRIPTION</th>
                        <th>HSN</th>
                        <th>QTY</th>
                        <th>RATE</th>
                        <th>TAXABLE AMOUNT</th>
                        <th>TAX (%)</th>
                        <th>TAX AMOUNT</th>
                        <th>TOTAL AMOUNT</th>
                        <th>DEP (%)</th>
                        <th>DEP AMOUNT</th>
                        <th>R&R CHARGES</th>
                        <th>REPAIR CHARGES</th>
                        <th>PAINTING CHARGES</th>
                    </tr>
                </thead>
                <tbody>
                    {data.parts.map((part, i) => (
                        <tr >
                            <td>{data.sn}</td>
                            <td>{data.job}</td>
                            <td>{data.material}</td>
                            <td>{data.description}</td>
                            <td>{data.hsn}</td>
                            <td>{data.qty}</td>
                            <td>{data.rate}</td>
                            <td>{data.taxableAmount}</td>
                            <td>{data.taxPercent}</td>
                            <td>{data.taxAmount}</td>
                            <td>{data.totalAmount}</td>
                            <td>{data.depPercent}</td>
                            <td>{data.depAmount}</td>
                            <td>{data.rrCharges}</td>
                            <td>{data.repairCharges}</td>
                            <td>{data.paintingCharges}</td>
                        </tr>
                    ))}
                    {data?.parts && (
                        <tr className="subtotal-row">
                            <td colSpan="7"><strong>Subtotal</strong></td>
                            <td>
                                ₹{data.parts.reduce((sum, p) => sum + Number(p.qty) * Number(p.rate), 0).toFixed(2)}
                            </td>
                            <td></td>
                            <td>
                                ₹{data.parts.reduce((sum, p) => {
                                    const taxBase = Number(p.qty) * Number(p.rate);
                                    return sum + (taxBase * Number(p.taxPercent)) / 100;
                                }, 0).toFixed(2)}
                            </td>
                            <td>
                                ₹{data.parts.reduce((sum, p) => {
                                    const taxBase = Number(p.qty) * Number(p.rate);
                                    const taxAmount = (taxBase * Number(p.taxPercent)) / 100;
                                    return sum + taxBase + taxAmount;
                                }, 0).toFixed(2)}
                            </td>
                            <td></td>
                            <td>
                                ₹{data.parts.reduce((sum, p) => {
                                    const taxBase = Number(p.qty) * Number(p.rate);
                                    return sum + (taxBase * Number(p.depPercent)) / 100;
                                }, 0).toFixed(2)}
                            </td>
                            <td colSpan="5"></td>
                        </tr>
                    )}
                </tbody>
            </table>

            <table className="labor-table">
                <thead>
                    <tr>
                        <th>LABOUR TYPE</th>
                        <th>TAXABLE AMOUNT</th>
                        <th>TAX AMOUNT</th>
                        <th>TOTAL AMOUNT</th>
                        <th>DEP AMOUNT</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.labourDetails?.length > 0 ? (
                        data.labourDetails.map((labour, i) => (
                            <tr key={i}>
                                <td>{labour.labourType || '-'}</td>
                                <td>{labour.taxableAmount && labour.taxableAmount !== 'Not Found' ? `₹${labour.taxableAmount}` : '-'}</td>
                                <td>{labour.taxAmount && labour.taxAmount !== 'Not Found' ? `₹${labour.taxAmount}` : '-'}</td>
                                <td>{labour.totalAmount && labour.totalAmount !== 'Not Found' ? `₹${labour.totalAmount}` : '-'}</td>
                                <td>{labour.depAmount && labour.depAmount !== 'Not Found' ? `₹${labour.depAmount}` : '-'}</td>
                            </tr>
                        ))
                    ) : (
                        <>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        </>
                    )}
                </tbody>
                {/* <tbody>

                    <tr>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                    </tr>

                    <tr >
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                </tbody> */}
            </table>

            <table className="final-table">
                <thead>
                    <tr>
                        <th>FINAL CALCULATION</th>
                        <th>AMOUNT</th>
                    </tr>
                </thead>
                  <tbody>
                    <tr>
                        <td>Total Liability</td>
                        <td>{data?.finalCalculation?.totalLiability && data.finalCalculation.totalLiability !== 'Not Found' ? `₹${data.finalCalculation.totalLiability}` : '--'}</td>
                    </tr>
                    <tr>
                        <td>Compulsory Deductible</td>
                        <td>{data?.finalCalculation?.compulsoryDeductible && data.finalCalculation.compulsoryDeductible !== 'Not Found' ? `₹${data.finalCalculation.compulsoryDeductible}` : '--'}</td>
                    </tr>
                    <tr>
                        <td>Voluntary Deductible</td>
                        <td>{data?.finalCalculation?.voluntaryDeductible && data.finalCalculation.voluntaryDeductible !== 'Not Found' ? `₹${data.finalCalculation.voluntaryDeductible}` : '--'}</td>
                    </tr>
                    <tr>
                        <td>Salvage Deductions</td>
                        <td>{data?.finalCalculation?.salvageDeductions && data.finalCalculation.salvageDeductions !== 'Not Found' ? `₹${data.finalCalculation.salvageDeductions}` : '--'}</td>
                    </tr>
                    <tr>
                        <td>Non-Standard Amount</td>
                        <td>{data?.finalCalculation?.nonStandardAmount && data.finalCalculation.nonStandardAmount !== 'Not Found' ? `₹${data.finalCalculation.nonStandardAmount}` : '--'}</td>
                    </tr>
                    <tr>
                        <td>Towing Amount</td>
                        <td>{data?.finalCalculation?.towingAmount && data.finalCalculation.towingAmount !== 'Not Found' ? `₹${data.finalCalculation.towingAmount}` : '--'}</td>
                    </tr>
                    <tr className="total-row">
                        <td>Liability</td>
                        <td>{data?.finalCalculation?.digitLiability && data.finalCalculation.digitLiability !== 'Not Found' ? `₹${data.finalCalculation.digitLiability}` : '--'}</td>
                    </tr>
                </tbody>
                {/* {<tbody>
                    <tr>
                        <td>Total Liability</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Compulsary Deductable</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Voluntary Deductible</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Salvage Deductions</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Non-Standard Amount</td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Towing Amount</td>
                        <td>--</td>
                    </tr>
                    <tr className="total-row">
                        <td>Digit Liability</td>
                        <td>--</td>
                    </tr>
                </tbody>} */}
            </table>

            <div className="note-section">
                <div className="section-heading">ASSESSMENT NOTES</div>
                <ul className="assessment-notes">

                    <li>Any additional amount over and above the approved assessment shall be borne by the Insured.</li>
                    <li>The final liability has been arrived at as full and final settlement after consent from the Insured. Do get back to us within the next 24 hours for any queries or clarifications.</li>
                </ul>
            </div>


        </div>
    );
};

export default WorkApprovalReport;
